import { Flame } from "lucide-react";
import { Metrics } from "@/components/Metrics";
import { KanbanBoard } from "@/components/KanbanBoard";
import { NewOrderDialog } from "@/components/NewOrderDialog";
import { PageHeader } from "@/components/PageHeader";
import { useOrders } from "@/lib/OrdersContext";

const UrgentFilter = () => {
  const { orders, onlyUrgent, setOnlyUrgent } = useOrders();
  const count = orders.filter((o) => o.urgente).length;
  return (
    <button data-testid="urgent-filter-btn" onClick={() => setOnlyUrgent(!onlyUrgent)} aria-pressed={onlyUrgent}
      className={`flex items-center gap-2 rounded-lg border px-4 py-2.5 text-sm font-semibold transition-colors duration-200 ${onlyUrgent ? "border-orange-500 bg-orange-500 text-black" : "border-white/10 text-zinc-300 hover:border-orange-500 hover:text-orange-400"}`}>
      <Flame className="h-4 w-4" /> Solo urgentes
      <span data-testid="urgent-filter-count" className={`rounded px-1.5 text-xs ${onlyUrgent ? "bg-black/20" : "bg-white/5"}`}>{count}</span>
    </button>
  );
};

export default function KanbanPage() {
  return (
    <div className="space-y-8">
      <PageHeader title="Panel Kanban" subtitle="Arrastra las órdenes entre columnas o usa “Mover” en cada tarjeta.">
        <div className="flex flex-wrap items-center gap-2">
          <UrgentFilter />
          <NewOrderDialog />
        </div>
      </PageHeader>
      <Metrics />
      <KanbanBoard />
    </div>
  );
}
